import styled, { css } from "styled-components";
import { Device } from "../../../../styles/screenSizes";

export const StyledMobileMenu = styled.div`
  display: flex;
  flex-direction: column;

  @media ${Device.laptop} {
    display: none;
  }
`;

export const StyledMenu = styled.div<{ isMenuOpen: boolean }>`
  @media ${Device.notLaptop} {
    ${({ isMenuOpen }) =>
      isMenuOpen
        ? css`
            z-index: 1;
            background-color: ${({ theme }) => theme.color.disabled};
            color: ${({ theme }) => theme.color.primary};
            position: fixed;
            height: 100%;
            width: 100%;
            left: 0;
            top: 60px;
            display: flex;
            flex-direction: column;
          `
        : `display: none;`};
  }
`;

export const StyledLink = styled.div`
  color: ${({ theme }) =>
    theme.header?.portal?.mobileLinkColor || theme.color.primary};
  background-color: ${({ theme }) =>
    theme.header?.portal?.backgroundColor || "#fff"};
  height: 60px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  border-bottom: 1px solid #ebebeb;
`;
